export const Form = Object.freeze({
  address: 'address',
  aditionalInfo: 'aditional-info',
  alternateVehicle: 'alternate-vehicle',
  auth: 'auth',
  beneficiaries: 'beneficiaries',
  biometrics: 'biometrics',
  contact: 'contact',
  coverage: 'coverage',
  customer: 'customer',
  device: 'device',
  identification: 'identification',
  insured: 'insured',
  insuredAmount: 'insured-amount',
  moto: 'moto',
  paymentInfo: 'payment-info',
  pep: 'pep',
  pet: 'pet',
  realState: 'real-state',
  realStateAddress: 'real-state-address',
  resume: 'resume',
  specialConditions: 'special-conditions',
  tos: 'tos',
  travel: 'travel',
  vehicle: 'vehicle',
})

export type Form = PropsTypesOf<typeof Form>
